import "./App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home.jsx";
import AboutPage from "./pages/about/AboutPage.jsx";
import CellClubPage from "./pages/cell-club/CellClubPage.jsx";
import UniversityAdmPage from "./pages/about/university-administration/UniversityAdmPage.jsx";
import CampusAdmPage from "./pages/about/campus-administration/CampusAdmPage.jsx";
import FacultiesOfArtsPages from "./pages/faculty/faculty-of-arts/FacultiesOfArtsPages.jsx";
import CentralLibraryPage from "./pages/central-library/CentralLibraryPage.jsx";
import ExaminationCellPage from "./pages/examination-cell/ExaminationCellPage.jsx";
import InfrastructureFacilitiesPage from "./pages/infrastructure-facilities/InfrastructureFacilitiesPage.jsx";
import NirfPage from "./pages/NirfPage";
import SdcNepPage from "./pages/SdcNepPage";
import RecruitmentPage from "./pages/events/RecruitmentPage.jsx";
import DepartmentDetail from "./pages/department/DepartmentDetail.jsx";
// import CollegeListPage from "./pages/about/affiliation/CollegeListPage.jsx";
import StudentCornerPage from "./pages/student-corner/StudentCornerPage.jsx";
import NoticesPage from "./components/NoticesPage.jsx";
import ExaminationCellNoticesPage from "./pages/examination-cell/ExaminationCellNoticesPage.jsx";
import TeacherCV from "./pages/TeacherCV";

function App() {
  // ================= FONT SIZE =================
  const [fontScale, setFontScale] = useState(1);

  const increaseFont = () => {
    setFontScale((prev) => Math.min(prev + 0.1, 1.3));
  };

  const decreaseFont = () => {
    setFontScale((prev) => Math.max(prev - 0.1, 0.8));
  };

  const resetFont = () => {
    setFontScale(1);
  };

  // ================= MAINTENANCE POPUP =================
  // const [showMaintenance, setShowMaintenance] = useState(true);

  return (
    <div className="App">

      {/* ================= MAINTENANCE POPUP ================= */}
      {/* {showMaintenance && (
        <div className="maintenance-overlay">
          <div className="maintenance-modal">

            <h2 className="font-gill text-red-800">Notice</h2>

            <p className="font-gill">
              This website is currently under maintenance and testing.
            </p>

            <button
              type="button"
              onClick={() => setShowMaintenance(false)}
            >
              OK
            </button>

          </div>
        </div>
      )} */}

      {/* ================= WEBSITE ================= */}
      <BrowserRouter>
        <div style={{ zoom: fontScale }}>

          <Routes>

            <Route path="/" element={<Home />} />

            <Route
              path="/about/:slug"
              element={<AboutPage />}
            />

            <Route
              path="/about/university-administration/:slug"
              element={<UniversityAdmPage />}
            />

            <Route
              path="/about/campus-administration/:slug"
              element={<CampusAdmPage />}
            />

            <Route
              path="/faculty/:facultySlug/:slug"
              element={<FacultiesOfArtsPages />}
            />

            <Route
              path="/central-library"
              element={<CentralLibraryPage />}
            />

            <Route
              path="/examination-cell"
              element={<ExaminationCellPage />}
            />

            <Route
              path="/infrastructure-facilities/:slug"
              element={<InfrastructureFacilitiesPage />}
            />

            <Route
              path="/cell-club/:slug"
              element={<CellClubPage />}
            />

            <Route
              path="/nirf"
              element={<NirfPage />}
            />

            <Route
              path="/sdcnep"
              element={<SdcNepPage />}
            />

            <Route
              path="/events/:slug"
              element={<RecruitmentPage />}
            />

            <Route
              path="/student-corner/:slug"
              element={<StudentCornerPage />}
            />

            <Route
              path="/department/:facultySlug/:slug"
              element={<DepartmentDetail />}
            />
            {/* <Route
              path="affiliation/colleges-list"
              element={<CollegeListPage />}
            /> */}

<Route path="/notices" element={<NoticesPage />} />
<Route
  path="/examination-cell/notices"
  element={<ExaminationCellNoticesPage />}
/>
<Route path="/teacher/:id/cv" element={<TeacherCV />} />
          </Routes>

        </div>
      </BrowserRouter>

    </div>
  );
}

export default App;